import React, { memo } from 'react';
import PropTypes from 'prop-types';
import MuiButton from '@mui/material/Button';
import { makeStyles } from 'src/makeStyles';
import DeleteIcon from '@mui/icons-material/Delete';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles()({
  button: {
    padding: 1,
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '14px',
    borderRadius: 4,
    minWidth: 0,
    color: colors.grey2,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      color: colors.websiteLinkColor,
    },
  },
  disabled: {
    '&.MuiButton-root.Mui-disabled': {
      color: colors.grey2Opacity60,
    },
  },
  labe: {
    marginLeft: 10,
  },
});

const DeleteButton = ({ label, className, disabled, ...rest }) => {
  const { classes, cx } = useStyles();

  return (
    <MuiButton
      className={classes.button}
      classes={{ disabled: classes.disabled }}
      variant="text"
      disabled={disabled}
      {...rest}
    >
      <DeleteIcon fontSize="small" />
      {label && <span className={classes.label}>{label}</span>}
    </MuiButton>
  );
};

DeleteButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};

DeleteButton.defaultProps = {
  disabled: false,
};

export default memo(DeleteButton);
